var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty4Little(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.058,
    height: 26.389,
    viewBox: "0 0 46.058 26.389",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32",
    "data-name": "Trac\\xE9 32",
    d: "M126.163,265.076s7.316,1.125,2.814,6.472-15.476,1.407-19.134-.281-8.723-1.407-12.381,0-10.13-.281-9.849-5.346.844-5.065-1.407-8.723-1.688-6.191.844-8.723",
    transform: "translate(-84.634 -248.12)",
    fill: "none",
    stroke: "#f3f3f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    strokeDasharray: "1.5 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty4Little);
export default __webpack_public_path__ + "static/media/empty-4-little.69030188c0ef13fda66c640a216a7550.svg";
export { ForwardRef as ReactComponent };